import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60); // 24 hours in seconds
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    // Check local storage for start time
    const storedStartTime = localStorage.getItem('herbolaria_timer_start');
    const now = Date.now();
    if (!storedStartTime) {
      localStorage.setItem('herbolaria_timer_start', now.toString());
    } else {
      const elapsed = Math.floor((now - parseInt(storedStartTime)) / 1000);
      const remaining = 24 * 60 * 60 - elapsed;
      if (remaining > 0) {
        setTimeLeft(remaining);
      } else {
        // Reset if expired for demo purposes, or keep at 0
        setTimeLeft(0);
      }
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  if (timeLeft <= 0) return null;
  return <AnimatePresence data-id="element-10">
      {isVisible && <motion.div initial={{
      y: -50
    }} animate={{
      y: 0
    }} className="sticky top-0 z-50 w-full bg-red-700 text-white py-2 px-4 shadow-md text-center font-medium text-sm md:text-base flex justify-center items-center gap-2" data-id="element-11">
          <Clock className="w-4 h-4" data-id="element-12" />
          <span data-id="element-13">
            OFERTA POR TIEMPO LIMITADO: Termina en {formatTime(timeLeft)}
          </span>
        </motion.div>}
    </AnimatePresence>;
}